import { CalendarDay } from 'further-ui/utils';
import api from 'lib/trpcClient';
import { useEffect, useState } from 'react';

type ShareCapitalAllocation = {
  commitmentId: string;
  amountLcy: number;
  investorLabel: string;
  totalCommitmentLcy: number;
  unallocatedCommitmentLcy: number;
  allocationPercentage: number;
  recallableDistributionLcy: number;
  availableToBeCalledLcy: number;
  excludeFromAllocation: boolean;
  closeDate: CalendarDay;
  fundsCalled: {
    fromCommitmentLcy: number;
    fromRecallableDistributionLcy: number;
  };
};

export default function useAllocateShareCapital({
  vehicleId,
  onSuccess,
  existingBreakdown,
}: {
  vehicleId: string;
  onSuccess: (allocations: Array<ShareCapitalAllocation>) => void;
  existingBreakdown: Array<{
    commitmentId: string;
    amountLcy: number;
    fundsCalled?: {
      fromCommitmentLcy: number;
      fromRecallableDistributionLcy: number;
    };
  }>;
}) {
  const [shareCapitalAllocations, setShareCapitalAllocations] = useState<
    Array<ShareCapitalAllocation>
  >([]);

  const { mutate, isPending } =
    api.capitalAction.allocateShareCapital.useMutation({
      onSuccess: (allocations) => {
        setShareCapitalAllocations(allocations);
        onSuccess(allocations);
      },
    });

  const allocateShareCapital = async () => {
    if (isPending) {
      return;
    }

    mutate({
      vehicleId,
      excludedCommitmentIds: [],
      existingBreakdown,
    });
  };

  useEffect(() => {
    allocateShareCapital();
  }, []);

  return {
    shareCapitalAllocations,
    isPending,
    allocateShareCapital,
  };
}
